"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNonce = exports.valuesForSigner = exports.signPayload = void 0;
var CryptoJS = __importStar(require("crypto-js"));
/**
 * Signs the payload to be send to Eden Auth Api
 *
 * @param key
 * @param context
 * @param payload
 */
function signPayload(key, context, payload) {
    var values = valuesForSigner(payload);
    var hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, CryptoJS.enc.Base64.parse(key));
    hmac.update("".concat(context.timestamp, "|"));
    hmac.update(CryptoJS.enc.Base64.parse(context.nonce));
    hmac.update('|');
    hmac.update(values.join('|'));
    if (context.previousSignature) {
        hmac.update('|');
        hmac.update(CryptoJS.enc.Base64.parse(context.previousSignature));
    }
    return CryptoJS.enc.Base64.stringify(hmac.finalize());
}
exports.signPayload = signPayload;
/**
 * Converts the payload to a string array
 *
 * @param payload
 */
function valuesForSigner(payload) {
    if (Array.isArray(payload)) {
        return payload.flatMap(valuesForSigner);
    }
    switch (typeof payload) {
        case 'object':
            return ((payload &&
                Object.keys(payload)
                    .sort()
                    .flatMap(function (key) { return valuesForSigner(payload[key]); })) || ['null']);
        case 'string':
            return [payload];
        case 'number':
            return ["".concat(payload)];
        case 'undefined':
            return [];
    }
    throw Error("Unknown type: ".concat(typeof payload));
}
exports.valuesForSigner = valuesForSigner;
/**
 * Generates a random 32 bit string
 */
function generateNonce() {
    return CryptoJS.enc.Base64.stringify(CryptoJS.lib.WordArray.random(32));
}
exports.generateNonce = generateNonce;
